import React, { Component } from 'react';
import './PaperPreview.css';
var classNames = require('classnames');
import Box from './Box';

class PaperPreview extends Component {


	render() {

		let classes = classNames([
			this.props.orientation,
			'PaperPreview'
		]);

		return (
			<div className={classNames(classes)}>
				<p className="title">{this.props.title}</p>
				<div className="items">
					<Box />
					<Box />
					<Box />
					<Box />
					<Box />
					<Box />
					<Box />
					<Box />
					<Box />
					<Box />
					<Box />
					<Box />
					{this.props.children}
				</div>
			</div>
		);
	}
}

export default PaperPreview;



// WEBPACK FOOTER //
// ./src/components/PaperPreview.js